const validateForm = (data) => {
  let errors = { hasError: false };
  if (!data.email) {
    errors.hasError = true;
    errors.email = true;
  }

  if (!data.password) {
    errors.hasError = true;
    errors.password = true;
  }

  return errors;
};

export default validateForm;